const $$splitComponentImporter = () => import('/opt/buildhome/repo/src/routes/petso/login.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/petso/login')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});